import React from "react";
import Reader from "./components/Reader";

import "./App.css";

const App = ({...props}) => {
  return <Reader {...props}/>
}

export default App;
